var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#BF96FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9626 25.8091C10.7402 25.8091 8.77511 25.7344 8.33433 23.1594L8.32617 13.1231C8.41392 12.1894 9.12201 10.5336 11.2034 10.515L13.1583 10.5295C13.444 9.5439 14.2541 7.5354 16.1295 7.5354C16.1417 7.5354 19.3414 7.47937 20.9024 7.5354C21.0636 7.55822 22.7778 7.90058 23.5287 10.5316H25.7795C26.5815 10.6042 28.0589 11.2495 28.3201 13.2061L28.3262 23.1055C28.2405 24.0039 27.6038 25.6306 25.7836 25.8049L10.9851 25.8091L10.9647 25.1679V24.8546V24.8318V25.8091H10.9626ZM11.2055 11.7993C9.73623 11.8138 9.59135 13.1314 9.58727 13.1854L9.58931 23.0495C9.83826 24.45 10.779 24.5268 10.9647 24.5268L10.9667 24.5289V24.5268V24.5289L25.7244 24.5268C26.8773 24.4127 27.0528 23.1781 27.0671 23.0391L27.063 13.2953C26.8753 11.9383 25.7693 11.8201 25.7224 11.8159L23.039 11.818C22.7431 11.818 22.486 11.6084 22.4227 11.3117C21.9472 9.10817 20.8025 8.81976 20.7535 8.80731C20.3413 8.80109 19.6495 8.79486 18.9537 8.79486C17.5538 8.79486 16.1417 8.81976 16.1397 8.81976C14.7684 8.81976 14.2745 11.2681 14.2705 11.293C14.2133 11.596 13.9154 11.8491 13.644 11.8159L11.2055 11.7993Z",
    fill: "url(#paint0_linear_12908_51443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3232 22.4688C15.9745 22.4688 14.0645 20.5266 14.0645 18.1384C14.0645 15.7502 15.9745 13.8081 18.3232 13.8081C20.6719 13.8081 22.582 15.7502 22.582 18.1384C22.584 20.5266 20.6719 22.4688 18.3232 22.4688ZM18.3232 15.0904C16.6703 15.0904 15.3255 16.4578 15.3255 18.1384C15.3255 19.8191 16.6703 21.1865 18.3232 21.1865C19.9761 21.1865 21.3209 19.8191 21.3209 18.1384C21.3209 16.4578 19.9761 15.0904 18.3232 15.0904Z",
    fill: "url(#paint1_linear_12908_51443)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0548 13.48C26.0548 13.7601 25.867 13.9884 25.6323 13.9884H23.9244C23.6917 13.9884 23.502 13.7622 23.502 13.48C23.502 13.1999 23.6897 12.9717 23.9244 12.9717H25.6323C25.865 12.9717 26.0548 13.1999 26.0548 13.48Z",
    fill: "url(#paint2_linear_12908_51443)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12908_51443",
    x1: 28.3262,
    y1: 7.5105,
    x2: 24.1476,
    y2: 28.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12908_51443",
    x1: 22.582,
    y1: 13.8081,
    x2: 20.4029,
    y2: 23.8449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12908_51443",
    x1: 26.0548,
    y1: 12.9717,
    x2: 25.9506,
    y2: 14.1966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#19162D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.5a31f3239b7cad1f0231daffa2b0b955.svg";
export { ForwardRef as ReactComponent };